import React from "react"

import { Tag, Tooltip } from "@synapse-analytics/synapse-ui"

// props passed to VersionTag.tsx -> ruleset versioning, workflow versioning
type versionTagProps = {
  version: number | undefined | string
  color: "green" | "blue" | "red"
  tooltip?: string
}

/**
 * VersionTag component, contains (ruleset, workflow) version
 * @param {number | undefined} version
 * @param {"positive" | "default"} variant
 * @return {<VersionTag />}
 */
export function VersionTag(props: Readonly<versionTagProps>): React.ReactElement {
  const { version, color = "blue", tooltip } = props
  return tooltip ? (
    <Tooltip title={tooltip} placement="top">
      <Tag color={color} size="small" style={{ textTransform: "lowercase" }}>{`v${version}`}</Tag>
    </Tooltip>
  ) : (
    <Tag color={color} size="small" style={{ textTransform: "lowercase" }}>{`v${version}`}</Tag>
  )
}
